const euroFormatterOptions = {
  useGrouping: true,
  style: 'currency',
  currency: 'EUR',
  currencyDisplay: 'narrowSymbol',
} as const;

const euroFormatterWhole = new Intl.NumberFormat('de-DE', {
  ...euroFormatterOptions,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const euroFormatterDecimal = new Intl.NumberFormat('de-DE', {
  ...euroFormatterOptions,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCurrency(value: number) {
  return (Math.round(value * 100) % 100 === 0 ? euroFormatterWhole : euroFormatterDecimal).format(value);
}

export function formatPrice(value: number, key = 'price') {
  const parts = euroFormatterWhole.formatToParts(value);
  const currencyIndex = parts.findIndex(({ type }) => type === 'currency');
  const currency = parts[currencyIndex]?.value;
  const formattedValue = parts
    .filter((_, index) => index !== currencyIndex)
    .map(({ value }) => value)
    .join('');

  const elements = [
    <span
      key="price"
      itemProp={key}
      content={value.toString()}
    >
      {formattedValue}
    </span>,
    <span
      key="currency"
      itemProp={`${key}Currency`}
      content={euroFormatterOptions.currency}
    >
      {currency}
    </span>,
  ];

  if (currencyIndex === 0) elements.reverse();

  return <>{elements}</>;
}

export function formatDate(date: Date | string | number, locale = 'de-DE') {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  return date.toLocaleDateString(locale.replace('_', '-'), { year: 'numeric', month: 'long', day: 'numeric' });
}
